import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CERT_STATUS_TOOLTIPS, WORKFLOW_PHASE_STATUS_TOOLTIPS } from 'constants/status-tooltip.constants';
import { constants } from 'constants/constants';
import { ComputedFrom } from '@certemy/common';
import _get from 'lodash-es/get';

@Component({
  selector: 'cm-certificate-icon',
  templateUrl: './certificate-icon.component.html',
  styleUrls: ['./certificate-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CertificateIconComponent {
  @Input() certificate;
  @Input() phase = null;
  @Input() isWorkflow: boolean = false;

  @ComputedFrom('certificate', 'phase')
  get statusId() {
    if (this.phase) {
      return this.phase.colorData.statusColorId;
    }
    if (this.certificate.status_id === undefined) {
      return this.certificate.complianceStatus;
    }
    return this.certificate.status_id;
  }

  @ComputedFrom('isWorkflow', 'phase')
  get statusTooltip() {
    if (this.isWorkflow || this.phase) {
      return WORKFLOW_PHASE_STATUS_TOOLTIPS;
    }
    return CERT_STATUS_TOOLTIPS;
  }

  @ComputedFrom('statusId')
  get isAuditActive(): boolean {
    const { CORRECTIONS_REQUESTED, CREDENTIAL_PAUSED, UNDER_AUDIT } = constants.CERTIFICATE_STATUSES;
    return [CORRECTIONS_REQUESTED, CREDENTIAL_PAUSED, UNDER_AUDIT].includes(this.statusId);
  }

  @ComputedFrom('certificate')
  get logo() {
    if (this.certificate.certification_logo === undefined) {
      return _get(this.certificate, 'organization.logo', null);
    }
    return this.certificate.certification_logo;
  }

  @ComputedFrom('certificate', 'phase')
  get colorStatusId() {
    if (this.phase) {
      return this.phase.colorData.statusColorId;
    }
    if (this.certificate.status_color === undefined) {
      return this.certificate.statusColorId;
    }
    return this.certificate.status_color;
  }

  @ComputedFrom('certificate', 'phase')
  get allStepsPassed() {
    const stepInstances = this.phase
      ? this.phase.steps
      : this.certificate.step_instances ||
        this.certificate.stepInstances ||
        _get(this.certificate.currentPhase, 'steps');
    return stepInstances && stepInstances.every((step) => step.isPassedDueDate);
  }

  @ComputedFrom('allStepsPassed', 'isAuditActive', 'colorStatusId', 'statusTooltip')
  get tooltip() {
    return this.allStepsPassed || this.isAuditActive ? null : this.statusTooltip[this.colorStatusId];
  }
}
